<template>
	<router-view :key="$store.state.app.language" />
</template>

